export const LINHAS_POR_PAGINA = 20;

export function getOpcoesPeriodo(baseDate = new Date()) {
    return [-1, 0, 1].map(offset => {
        const date = new Date(baseDate.getFullYear(), baseDate.getMonth() + offset, 1);
        const mes = date.getMonth() + 1;
        const ano = date.getFullYear();

        return {
            label: `${String(mes).padStart(2, '0')}/${ano}`,
            value: `${mes}-${ano}`,
            mes,
            ano,
            isCurrent: offset === 0
        };
    });
}

export function buildLinhaRemuneracaoVendedor(vendedor) {
    const numeroFilial = vendedor.idfilial - 10000;
    const filial = vendedor.nome_filial
        ? `${numeroFilial} - ${vendedor.nome_filial}`
        : String(numeroFilial);

    return {
        idvendedor: vendedor.idvendedor,
        nome: vendedor.nome_vendedor,
        filial,
        cluster: vendedor.idcluster || '-'
    };
}

export function getColunasRemuneracaoVendedores() {
    return [
        { nome: 'Código', atributo: 'idvendedor', style: { minWidth: '110px', width: '110px' } },
        { nome: 'Nome', atributo: 'nome', style: { minWidth: '300px', width: '300px' } },
        { nome: 'Filial', atributo: 'filial', style: { minWidth: '240px', width: '240px' } },
        { nome: 'Cluster', atributo: 'cluster', style: { minWidth: '180px', width: '180px' } },
        { nome: 'Ação', atributo: 'acao', style: { minWidth: '90px', width: '90px', textAlign: 'center' } }
    ];
}

export function getLinhasPaginadas(rows, page) {
    if (!Array.isArray(rows)) {
        return rows;
    }

    const paginaAtual = Math.max(Number(page) || 1, 1);
    const inicio = (paginaAtual - 1) * LINHAS_POR_PAGINA;

    return rows.slice(inicio, inicio + LINHAS_POR_PAGINA);
}

export function getTotalPaginas(rows) {
    if (!Array.isArray(rows) || rows.length === 0) {
        return 1;
    }

    return Math.ceil(rows.length / LINHAS_POR_PAGINA);
}
